import { memo } from 'react'

import Checkbox from '@/atoms/Checkbox'
import useFilters from '@/hooks/useFilters'

import select from '../functions/select'
import { ListProps } from '../ts'

function List({ category, options }: ListProps) {
  const filters = useFilters()
  const categoryFilters = filters?.[category] || []

  return (
    <ul className="flex flex-col space-y-4">
      {options.map(({ id, name }) => {
        const key = `${category}_${name}_${id}`
        const checked = categoryFilters?.includes(id)

        return (
          <li key={key}>
            <Checkbox
              id={key}
              data-id={id}
              name={name}
              label={name}
              onChange={(event) => select(event, category)}
              checked={checked}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default memo(List)
